import useStyles from 'isomorphic-style-loader/useStyles';
import type { SemanticICONS } from 'semantic-ui-react';
import { Icon } from 'semantic-ui-react';

import type { StatusVariant } from '@components/abstract-status';

import { AppVersionStatus } from '../../applications.models';

import s from './application-version-status-description.scss';

export const STATUSES: Array<{
  status: AppVersionStatus;
  icon: SemanticICONS;
  variant: StatusVariant;
  label: string;
  detail: string;
}> = [
  {
    status: AppVersionStatus.InProgress,
    icon: 'hourglass half',
    variant: 'primary',
    label: 'In Progress',
    detail: 'Actively being developed. Not yet released.',
  },
  {
    status: AppVersionStatus.Released,
    icon: 'rocket',
    variant: 'secondary',
    label: 'Released',
    detail: 'Published and available for use.',
  },
  {
    status: AppVersionStatus.Eol,
    icon: 'minus circle',
    variant: 'muted',
    label: 'EOL',
    detail: 'End of life — No longer maintained or supported.',
  },
];

/**
 * Legend explaining the three application version lifecycle statuses.
 * Designed to be passed as the `description` of the Status column so it
 * renders inside the shared column-header tooltip popup.
 */
export const ApplicationVersionStatusDescription = () => {
  useStyles(s);

  return (
    <div className={s.root}>
      <div className={s.title}>Version Status</div>
      {STATUSES.map(({ status, icon, variant, label, detail }) => (
        <div key={status} className={s.row}>
          <div className={`${s.statusLabel} ${s[variant]}`}>
            <Icon name={icon} />
            <span>{label}</span>
          </div>
          <div className={s.detail}>{detail}</div>
        </div>
      ))}
    </div>
  );
};

export default ApplicationVersionStatusDescription;
